export default "__VITE_ASSET__7dd9719f__"